// AUTHOR: GOPALAKRISHNAN
// VERSION: 0.0.1
// LAST EDIT: GOPALAKRISHNAN
// DATE: 05/01/2026
// DESCRIPTION: DEALER REPORT PAGE SAGA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import DealerReportActionTypes from './dealer-report.types';
import { fetchDealerReport } from './dealer-report.service';
import {
	fetchDealerReportSuccess,
	fetchDealerReportFailure,
	fetchDealerReportResponseChanged,
} from './dealer-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ***************** GET DEALER REPORT DETAILS START *********************** */
export function* fetchDealerReportDetails({ payload }: any) {
	try {
		const key = 'DealerReportKey';
		const { databaseName, fromDate, toDate, dealerID, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			DealerID: dealerID,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchDealerReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchDealerReportFailure(responseData.data));
		} else {
			yield put(fetchDealerReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchDealerReportFailure(error));
	}
}

export function* resetFetchDealerReportResponse() {
	yield put(fetchDealerReportResponseChanged());
}

export function* onFetchDealerReport() {
	yield takeLatest(DealerReportActionTypes.FETCH_DEALER_REPORT_START, fetchDealerReportDetails);
}

export function* onFetchDealerReportResponseReset() {
	yield takeLatest(
		DealerReportActionTypes.FETCH_DEALER_REPORT_RESPONSE_RESET,
		resetFetchDealerReportResponse,
	);
}
/** ***************** GET DEALER REPORT DETAILS START *********************** */
export function* dealerReportSaga() {
	yield all([call(onFetchDealerReport), call(onFetchDealerReportResponseReset)]);
}
